import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  setSelectOptions,
  setSelectLoading,
  setSelectError,
} from "../../store/patient/selectOptionsSlice";
import { translations } from "../../helpers";

export const useSelectOptionsStore = () => {
  const dispatch = useDispatch();

  const { surgeryRooms, doctors } = useSelector(
    (state) => state.patient.selectOptions
  );

  const getSurgeryRoomsByIpsId = useCallback(
    async ({ ipsId }) => {
      try {
        dispatch(setSelectLoading({ key: "surgeryRooms" }));

        const { data } = await gosafeApi.get(`surgeryRoom/ips/${ipsId}`);

        dispatch(setSelectOptions({ key: "surgeryRooms", data }));

        return;
      } catch (error) {
        dispatch(
          setSelectError({
            key: "surgeryRooms",
            message:
              translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message,
          })
        );
        return;
      }
    },
    [dispatch]
  );

  const getDoctorsByIpsId = useCallback(
    async ({ ipsId }) => {
      try {
        dispatch(setSelectLoading({ key: "doctors" }));

        const { data } = await gosafeApi.get(`doctor/listByIpsId/${ipsId}`);

        dispatch(setSelectOptions({ key: "doctors", data }));
        return;
      } catch (error) {
        dispatch(
          setSelectError({
            key: "doctors",
            message:
              translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message,
          })
        );
        return;
      }
    },
    [dispatch]
  );

  return {
    // Props
    surgeryRooms,
    doctors,

    // Methods
    getSurgeryRoomsByIpsId,
    getDoctorsByIpsId,
  };
};
